var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasPermissions)?_c('error',{attrs:{"error":_vm.error}}):_vm._e(),(_vm.hasPermissions)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }